// extracted by mini-css-extract-plugin
export default {"popularTitle":"Popular_popularTitle__kDgy+","popular1":"Popular_popular1__L+j2G","popular2":"Popular_popular2__Bne2r"};